define('views/restaurant-map',['underscore', 'backbone', 'classes/templator', 'classes/map', 'async!https://maps.googleapis.com/maps/api/js?key=AIzaSyDjy1KlfeAFWsbY1B_D9cogMzR9hLJ-A44'],
  function(_, Backbone, templator) {

    var current_restaurant_id = typeof window.current_restaurant_id != 'undefined' ? window.current_restaurant_id : null;

    var RestaurantMapView = Backbone.View.extend({

      template: templator.restaurantMap,

      initialize: function(options) {
        _.extend(this, _.pick(options, 'map'));
        this.render();
      },

      render: function() {
        var selected = this.model.id == current_restaurant_id ? '-selected' : '';
        var marker = new google.maps.Marker({
          position: new google.maps.LatLng(this.model.get('latitude'), this.model.get('longitude')),
          icon: '//cdn' + cdn_base + '.menucosm.' + cdn_domain + '/img/marker' + selected + '.png',
          map: this.map
        });

        var closed = _.isEmpty(this.model.get('open_today'));

        var extra_template_params = {
          thumb_width: map_thumb_dimensions['width'],
          thumb_height: map_thumb_dimensions['height'],
          open_closed: closed ? 'Closed today' : 'Open today: ',
          open_time: closed ? '' : this.model.get('open_today')
        }

        var content = this.template(_.extend(this.model.attributes, extra_template_params));

        var this_ = this;
        google.maps.event.addListener(marker, 'click', function() {
          this_.map.info_window.close();
          this_.map.info_window.setContent(content);
          this_.map.info_window.open(this_.map, marker);
        });

        if (this.model.id == current_restaurant_id) {
          new google.maps.event.trigger(marker, 'click');
        }
      }

    });

    return RestaurantMapView;

  }
);
